import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Table } from 'primeng';
import { LazyLoadEvent, SelectItem } from 'primeng';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IInboxJob } from '../../interfaces/inbox-job';
import { IInboxJobFilter } from '../../interfaces/inbox-job-filter';
import { IPageResult } from '../../interfaces/page-result';
import { EngineiusRegionService, JobsService, TaggingService } from '../../services';
import { FilterStateService } from '../../services';
import { InboxBackService } from '../../services';
import { InboxJobsService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { flatten } from '../../utils/flatten';
import { EngineiusAreaService } from '../../services';
import { IEArea } from '../../interfaces/earea';
import { IERegion } from '../../interfaces/eregion';
import { DeployPriorityGradingsService } from '../../services';
import { IDeployPriorityGrading } from '../../interfaces/deploy-priority/deploy-priority-grading';
import moment from 'moment';
import { IOrderDTO } from '../../interfaces/task-info';
import { ITagEntity } from 'src/app/interfaces/tag-entity';
import { Message } from '../../classes/Message';
import { JobStage } from '../../enums/job-stage';
import { RouteRecommendationService } from '../../services/route-recommendation.service';

interface IDeployPriorityGradingOption extends IDeployPriorityGrading {
  value: number;
}

@Component({
  selector: 'vme-jobs-grid',
  templateUrl: './vme-jobs-grid.component.html',
  styleUrls: ['./jobs-inbox.scss'],
  encapsulation: ViewEncapsulation.None, // todo: check why
})
export class VmeJobsGridComponent implements OnInit {
  private subscription: Subscription;

  public type_inboxSupplierToBeConfirmed = 1;
  public type_inboxAwaitingStart = 2;
  public type_inboxCompletedJobs = 3;
  public type_inboxCombine = 4;
  public type_inboxWaitingForApproval = 5;
  public type_inboxCancelled = 9;
  public type_GlobalFilter = 10;
  public type_inboxDeploy = 11;
  public type_inboxExistingCapacity = 12;
  //6 - live orders
  public type_inboxLiveJobs = 6;
  public type_inboxUrgentJobs = 7;
  public type_inboxClosed = 8;

  public urgencyType_None = 0;
  public urgencyType_AboutToStart = 1;
  public urgencyType_BidIsRunningOut = 2;

  taskTypes: SelectItem[] = [];
  //customersDefSelect: SelectItem = { label: "All Customers", value: 0 }
  private _customers: SelectItem[] = [];
  private allAreas: IEArea[];
  private allRegions: IERegion[];

  @Input('customers')
  set customers(value: SelectItem[]) {
    this._customers = value;
    if (this._customers) {
      this._customers = this._customers.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    }
  }

  get customers(): SelectItem[] {
    return this._customers;
  }

  //suppliersDefSelect: SelectItem = { label: "All Suppliers", value: 0 }
  private _suppliers: SelectItem[] = [];
  @Input('suppliers')
  set suppliers(value: SelectItem[]) {
    this._suppliers = value;
    if (this._suppliers) {
      this._suppliers = this._suppliers.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    }
  }

  get suppliers(): SelectItem[] {
    return this._suppliers;
  }

  eregions: SelectItem[] = [];
  eareas: SelectItem[] = [];
  customerDepartments: SelectItem[] = [];
  customerTeams: SelectItem[] = [];

  stages: SelectItem[] = [
    { label: 'All Stages', value: 0 },
    { label: 'Held', value: JobStage.Held },
    { label: 'Existing Capacity', value: JobStage.Capacity },
    { label: 'Buy It Now', value: JobStage.BuyNow },
    { label: 'Grab Disabled', value: JobStage.GrabDisabled },
  ];

  public deployPriorityGradings: SelectItem[] = [];

  public tagsOptions: SelectItem[] = [];

  public gradings: Map<number, IDeployPriorityGrading> = new Map<number, IDeployPriorityGrading>();

  public tagingsMap: Map<number, ITagEntity> = new Map<number, ITagEntity>();

  public selectedJobs: IInboxJob[];
  public selectedJob: IInboxJob;

  private _stageId: number;
  @Input('stageId')
  set stageId(value: number) {
    this._stageId = value;
  }

  get stageId(): number {
    return this._stageId;
  }

  //---exported params
  @Output() jobSelectionChanged: EventEmitter<any>;
  @Output() onGridAction: EventEmitter<any>;

  private _inboxType: number;
  @Input('inboxType')
  set inboxType(value: number) {
    this._inboxType = value;
  }

  get inboxType(): number {
    return this._inboxType;
  }

  @Output() totalCountChanged: EventEmitter<any>;
  private _totalCount: number;
  set totalCount(value: number) {
    this._totalCount = value;
    this.totalCountChanged.emit(value);
  }

  get totalCount(): number {
    return this._totalCount;
  }

  //---/exported params

  //
  public isLoaded: boolean = false;
  public isLoading: boolean = false;
  public page: IPageResult<IInboxJob> = {
    items: [],
    total: 0,
  };

  private readonly itemsPerPageDef = 20;
  private readonly PRO_TAG = 'Pro';
  private readonly PRO_TAG_INCLUDE_OTHERS = 'Pro (Includes Others)';
  private readonly PRO_ONLY_TAG = {
    id: 99,
    name: 'Pro (Only)',
  } as ITagEntity;
  private defaultSortField = 'timeLeft';
  private defaultSortOrder = 1;
  public filter: Subject<IInboxJobFilter>;
  public filterVal: IInboxJobFilter;

  public showProgress: Boolean = false;

  public holdingJobs = false;
  public releasingJobs = false;
  public jobsReleaseDate: Date;
  public jobsMinReleaseDate: Date;
  public showHoldConfirmation = false;

  enablingGrab = false;
  disablingGrab = false;
  markingForCombine = false;

  routeInboxEnabled: boolean = false;
  routesContainingJobCount: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private inboxjobsService: InboxJobsService,
    private vmeInboxjobsService: VmeInboxJobsService,
    private engineiusRegionService: EngineiusRegionService,
    private engineiusAreaService: EngineiusAreaService,
    private deployPriorityGradingService: DeployPriorityGradingsService,
    public messageService: MessageService,
    private inboxBackService: InboxBackService,
    private filterStateService: FilterStateService,
    private taggingService: TaggingService,
    private confirmationService: ConfirmationService,
    private jobService: JobsService,
    private routeRecommendationService: RouteRecommendationService,
  ) {
    this.initDefaultFilter();
    this.jobSelectionChanged = new EventEmitter<any>();

    this.onGridAction = new EventEmitter<any>();
    this.totalCountChanged = new EventEmitter<any>();
  }

  ngOnInit() {
    this.showProgress = true;

    if (this.inboxType == this.type_inboxClosed) {
      this.defaultSortField = 'closedDate';
      this.defaultSortOrder = 1;
    } else if (this.inboxType == this.type_inboxCompletedJobs) {
      this.defaultSortField = 'lastTaskCompleted';
      this.defaultSortOrder = -1; // descending
    } else if (this.inboxType == this.type_inboxCancelled) {
      this.defaultSortField = 'jobLastUpdated';
      this.defaultSortOrder = 1;
    }

    if (
      this.filterStateService.inboxJobFilterVal &&
      this.filterStateService.inboxJobFilterVal.filters.inboxType?.value == this.inboxType
    ) {
      this.filterVal = Object.assign({}, this.filterStateService.inboxJobFilterVal);

      this.filterStateService.inboxJobFilterVal = null;
    } else {
      this.initDefaultFilter();
    }

    this.loadCustomerDepartmentsTeams();

    //--grid filters
    this.inboxjobsService.bindTaskTypesWithoutDefault().then((res) => (this.taskTypes = res));

    this.deployPriorityGradingService.getGradings().then((result) => {
      this.gradings = new Map<number, IDeployPriorityGrading>(
        result.items.map((g) => [g.id, g] as [number, IDeployPriorityGrading]),
      );
      this.deployPriorityGradings = result.items.map((g) => ({
        value: g.id,
      }));

      this.taggingService.getAllTags().subscribe((result) => {
        this.setupTagging(result);
      });
    });

    this.bindERegions().then((res) => (this.eregions = res));

    this.bindEAreas().then((res) => (this.eareas = res));
    //--/grid filters

    this.filter = new Subject<IInboxJobFilter>();

    // subscribe to filter changes with a debounce time
    this.subscription = this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.loadCustomerTeams();
      this.filterVal = f;
      this.showProgress = false;
    });

    // set default filter
    this.filter.next(this.filterVal);

    this.loadRouteInboxEnabledFlag();
  }

  private loadCustomerDepartmentsTeams() {
    this.vmeInboxjobsService.getCustomerDepartments().then((deparmtents) => {
      this.customerDepartments = [];
      deparmtents.forEach((dept) =>
        this.customerDepartments.push({
          label: dept.name,
          value: dept.id,
        }),
      );
    });

    this.loadCustomerTeams();
  }

  private loadCustomerTeams() {
    const departmentIds = this.filterVal.filters.customerDepartmentList.value;
    this.vmeInboxjobsService
      .getInboxCustomerTeamsByDepartmentIds(departmentIds ?? [])
      .then((teams) => {
        this.customerTeams = [];
        teams.forEach((team) =>
          this.customerTeams.push({
            label: team.name,
            value: team.id,
          }),
        );
      });
  }

  private setupTagging(result: ITagEntity[]): void {
    if (!result) {
      return;
    }

    const proTag = result.find((x) => x.name === this.PRO_TAG);

    const filteredResult = result.filter((x) => x.name !== this.PRO_TAG);
    filteredResult.push(this.PRO_ONLY_TAG);
    if (proTag) {
      proTag.name = this.PRO_TAG_INCLUDE_OTHERS;
      filteredResult.push(proTag);
    } else {
      filteredResult.push({
        id: 2,
        name: this.PRO_TAG_INCLUDE_OTHERS,
      } as ITagEntity);
    }
    this.tagingsMap = new Map<number, ITagEntity>(
      filteredResult.map((g) => [g.id, g] as [number, ITagEntity]),
    );

    this.tagsOptions = filteredResult.map((tag) => ({
      label: tag.name,
      value: tag.id,
    }));
  }

  onTaggingChange(event: any) {
    if (this.filterVal.filters.selectedTagList.value.find((x) => x === this.PRO_ONLY_TAG.id)) {
      this.filterVal.filters.selectedTagList.value =
        this.filterVal.filters.selectedTagList.value.filter((x) => x == this.PRO_ONLY_TAG.id);
    }
  }

  bindERegions(): Promise<SelectItem[]> {
    return this.engineiusRegionService.getAll().then((res) => {
      this.allRegions = res;
      return this.filterERegions();
    });
  }

  bindEAreas(): Promise<SelectItem[]> {
    return this.engineiusAreaService.getAll().then((res) => {
      this.allAreas = res;
      let l = [];
      if (res != null) {
        res.forEach((item) => {
          l.push({ label: item.name, value: item.id });
        });
      }
      return l;
    });
  }

  filterERegions() {
    const selectedAreas = this.filterVal.filters.eAreaIdList.value;

    let l = [];
    if (this.allRegions != null) {
      this.allRegions
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter(
          (x) =>
            selectedAreas == null ||
            selectedAreas.length == 0 ||
            selectedAreas.includes(x.engineiusAreaId),
        )
        .forEach((item) => {
          l.push({ label: item.name, value: item.id });
        });
    }
    return l;
  }

  populateERegions() {
    this.eregions = this.filterERegions();
  }

  load(filter: IInboxJobFilter) {
    this.isLoading = true;

    this.vmeInboxjobsService.getPage(flatten(filter)).then((result) => {
      console.log('RESULT ', result);

      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
      this.isLoading = false;
      this.totalCount = result.total;

      this.selectedJobs = null;

      if (
        this.selectedJob != null &&
        this.page.items.find((o) => o.id == this.selectedJob.id) == null
      ) {
        this.deselectJob();
      }
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: this.itemsPerPageDef,
      sortField: this.defaultSortField, // ASC
      sortOrder: this.defaultSortOrder,
      filters: {
        inboxType: { value: this._inboxType },
        from: { value: null },
        to: { value: null },
        taskType: { value: 0 },
        stage: { value: this.stageId ? this.stageId : 0 },
        customerId: { value: 0 },
        supplierId: { value: 0 },
        engineiusRegionId: { value: 0 },
        regNo: { value: null },
        isRefresh: { value: false },
        cancelledDateFrom: { value: null },
        cancelledDateTo: { value: null },
        completedDateFrom: { value: null },
        completedDateTo: { value: null },
        taskTypeList: { value: null },
        actualTaskTypeList: { value: null },
        stageList: { value: null },
        customerIdList: { value: null },
        supplierIdList: { value: null },
        eRegionIdList: { value: null },
        customerDepartmentList: { value: null },
        customerTeamList: { value: null },
        eAreaIdList: { value: null },
        urgentOnly: { value: false },
        priorityOnly: { value: false },
        rescheduledOnly: { value: false },
        delayedOnly: { value: false },
        failedTasks: { value: null },
        deployPriorityGradingIdList: { value: null },
        unverifiedOnly: { value: false },
        selectedTagList: { value: null },
      },
    };

    if (this.inboxType == this.type_inboxCancelled) {
      this.filterVal.filters.cancelledDateFrom.value = moment().add('day', -14).toDate();
      this.filterVal.filters.cancelledDateTo.value = moment().toDate();
    }

    if (this.inboxType == this.type_inboxClosed) {
      this.filterVal.filters.completedDateFrom.value = moment().add('day', -14).toDate();
      this.filterVal.filters.completedDateTo.value = moment().toDate();
    }

    this.populateERegions();
  }

  onRowSelect(event) {
    //console.log("Row selected: ", event);

    this.jobSelectionChanged.emit([event.data, this.inboxType]);
  }

  deselectJobFromInbox() {
    this.selectedJob = null;
    this.routesContainingJobCount = 0;
  }

  deselectJob() {
    this.selectedJob = null;
    this.jobSelectionChanged.emit([null, this.inboxType]);
    this.routesContainingJobCount = 0;
  }

  markJobAsClicked(jobId) {
    var item = this.page.items.find((o) => o.id == jobId);
    if (item != null && !item.clicked) {
      item.clicked = true;
    }
  }

  tasksCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.tasksCount);
  }

  ordersCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.ordersCount);
  }

  customersCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.customersCount);
  }

  itemsCountPostfix(item, value, count) {
    if (value == null || value == '' || count < 2) return value;
    return value + ' (+' + (count - 1) + ')';
  }

  vehicleCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.vehiclesNum);
  }

  gridUpdate() {
    this.load(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filterVal.filters.isRefresh.value = false;
    this.filter.next(this.filterVal);

    this.deselectJob();
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    this.initDefaultFilter();
    this.filter.next(this.filterVal);

    this.deselectJob();
  }

  removeJobFromCombine(item) {
    this.vmeInboxjobsService.removeJobFromCombine(item.id).then(() => {
      this.onGridAction.emit([
        this.type_inboxCombine,
        this.type_inboxSupplierToBeConfirmed,
        this.type_inboxDeploy,
      ]);
    });
  }

  protected showConfirmCombineDialog: boolean = false;

  combineJobs() {
    // if any job is not grab-able, show warning dialog.
    this.showConfirmCombineDialog = this.page.items
      .filter(this.jobIsChecked)
      .some((o) => o.grabDisabled);

    if (!this.showConfirmCombineDialog) {
      this.confirmCombine();
    }
  }

  confirmCombine() {
    this.isLoading = true;
    var jobIDs = [];
    this.page.items.filter(this.jobIsChecked).forEach((o) => {
      jobIDs.push(o.id);
    });

    this.vmeInboxjobsService
      .combineJobs(jobIDs)
      .then((jobId) => {
        this.onGridAction.emit([
          this.type_inboxCombine,
          this.type_inboxSupplierToBeConfirmed,
          this.type_inboxDeploy,
        ]);

        if (jobId) window.open(`app/jobscreen/${jobId}?openSequenceEditor=true`, '_blank');

        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }

  jobIsChecked(job: any) {
    return job.checked;
  }

  uncombineJobs(item) {
    this.isLoading = true;

    this.vmeInboxjobsService
      .uncombineJobs(item.id)
      .then(() => {
        this.onGridAction.emit([
          this.type_inboxCombine,
          this.type_inboxSupplierToBeConfirmed,
          this.type_inboxDeploy,
        ]);

        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }

  markSelectedJobsForCombine() {
    if (!this.selectedJobs?.length) {
      return;
    }

    this.markingForCombine = true;

    this.vmeInboxjobsService
      .markJobsForCombine(this.selectedJobs.map((job) => job.id))
      .then(() => {
        this.onGridAction.emit([
          this.type_inboxCombine,
          this.type_inboxSupplierToBeConfirmed,
          this.type_inboxDeploy,
        ]);
        this.selectedJobs = [];
        this.selectedJob = null;
      })
      .catch(() => {
        this.messageService.add(
          Message.Error('Error occurred marking selected jobs for combining'),
        );
      })
      .finally(() => {
        this.markingForCombine = false;
      });
  }

  get selectedJobIds(): number[] {
    return this.selectedJobs?.map((job) => job.id) ?? [];
  }

  onAutoDirectQueued() {
    this.filter.next(this.filterVal);
    this.selectedJobs = [];
    this.selectedJob = null;
  }

  viewJob(item: any, event: MouseEvent, isJobDetailsTap: boolean = false): void {
    this.filterStateService.inboxJobFilterVal = this.filterVal;

    const url = this.getJobUrl(item.id, isJobDetailsTap);

    if (event?.ctrlKey || event?.metaKey) {
      window.open(url, '_blank');
    } else {
      void this.router.navigate([url]);
    }
  }

  private getJobUrl(jobId: string | number, isJobDetailsTap: boolean): string {
    const isDeployInbox = this.inboxType === this.type_inboxDeploy;

    return isDeployInbox && !isJobDetailsTap
      ? `app/job-deployment/${jobId}`
      : `app/jobscreen/${jobId}`;
  }

  showPriceDetails() {
    var param: any = {
      jobId: this.selectedJob.id,
      orderId: this.selectedJob.orderId,
      customerId: this.selectedJob.customerId,
    };

    if (this.selectedJob.supplierId) {
      param.supplierId = this.selectedJob.supplierId;
    }

    this.router.navigate(['app/pricedetails'], { queryParams: param });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refresh() {
    this.filterVal.filters.isRefresh.value = true; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);

    this.deselectJob();
  }

  isNoSupplierTab() {
    return (
      this.inboxType == this.type_inboxSupplierToBeConfirmed ||
      this.inboxType == this.type_inboxDeploy ||
      this.inboxType == this.type_inboxCombine
    );
  }

  getRowColour(rowData: any, index: number) {
    return this.inboxType == this.type_inboxAwaitingStart && rowData.cssClass;
  }

  isHideSupplierFilter() {
    return (
      this.inboxType == this.type_inboxSupplierToBeConfirmed ||
      this.inboxType == this.type_inboxDeploy ||
      this.inboxType == this.type_inboxCombine
    );
  }

  downloadToCSV() {
    this.vmeInboxjobsService.downloadToCSV(flatten(this.filterVal), this.inboxType);
  }

  getPickupDropoffDiffHours(item, isPickup): string {
    let from = isPickup ? item.earliestPickupDate : item.earliestDropOffDate;
    let to = isPickup ? item.latestPickupDate : item.latestDropOffDate;

    let diff = moment(to).diff(from, 'hours');
    return `${diff}hr`;
  }

  markPriority() {
    this.vmeInboxjobsService.markPriorityDeployment([this.selectedJob.id]).then(() => {
      this.onGridAction.emit([
        this.type_inboxCombine,
        this.type_inboxSupplierToBeConfirmed,
        this.type_inboxDeploy,
      ]);
    });
  }

  checkCarryOverAuthorised(row: IOrderDTO) {
    return row.tasks.filter((x) => x.carryOverAuthorised).length > 0;
  }

  rowIsRoute(row: IOrderDTO) {
    return row.routeRecommendationId != null;
  }

  rowHasDelayedTask(row: IOrderDTO) {
    return row.tasks.filter((x) => x.isDelayed == true).length > 0;
  }

  onJobSelectionChange(e: any) {
    console.log('Selection changed: ', e);
    console.log('Jobs Selected: ', this.selectedJobs);

    if (Array.isArray(this.selectedJobs)) {
      this.selectedJob = this.selectedJobs.length > 0 ? this.selectedJobs[0] : null;
    } else if (this.selectedJobs) {
      this.selectedJob = this.selectedJobs;
    } else {
      this.selectedJob = null;
    }

    if (this.selectedJob != null) {
      this.getRoutesContainingJobCount();
    }
  }

  holdSelectedJobs() {
    // just in case
    if (this.selectedJobs?.length == 0) {
      return;
    }

    const now = moment();

    // round to nearest 30 minutes
    const minutes = now.minutes();
    const roundedMinutes = Math.floor(minutes / 30) * 30;
    const roundedNow = moment(now).minutes(roundedMinutes).seconds(0);

    let releaseDefault = moment(roundedNow).add(1, 'day');
    this.jobsReleaseDate = releaseDefault.toDate();

    //  round current time up to next 30 min interval
    const nextInterval = Math.ceil(minutes / 30) * 30;
    const roundedUpNow = moment(now).minutes(nextInterval).seconds(0);
    this.jobsMinReleaseDate = moment(roundedUpNow).add(30, 'minutes').toDate();

    this.showHoldConfirmation = true;
  }

  getReleaseDays(): string {
    const now = moment();
    const releaseDate = moment(this.jobsReleaseDate);
    const diffMinutes = Math.abs(releaseDate.diff(now, 'minutes'));

    // Round up hours if 30+ minutes
    const totalHours = Math.ceil(diffMinutes / 60);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    if (days === 0) {
      return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    }
    if (hours === 0) {
      return `${days} ${days === 1 ? 'day' : 'days'}`;
    }
    return `${days} ${days === 1 ? 'day' : 'days'} and ${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  }

  doHoldJobs() {
    this.holdingJobs = true;

    const jobIds = this.selectedJobs.map((job) => {
      return job.id;
    });

    this.vmeInboxjobsService
      .holdJobs(jobIds, this.jobsReleaseDate)
      .then(() => {
        this.filter.next(this.filterVal);
        this.messageService.add(Message.Info('Selected jobs put in Hold state'));
      })
      .catch(() => {
        this.messageService.add(Message.Error('Error occurred holding selected jobs'));
      })
      .finally(() => {
        this.holdingJobs = false;
        this.showHoldConfirmation = false;
        this.selectedJobs = [];
        this.selectedJob = null;
      });
  }

  releaseSelectedJobs() {
    // just in case
    if (this.selectedJobs?.length == 0) {
      return;
    }

    const msg = `You are about to release ${this.selectedJobs.length} jobs from hold, are you sure you want to continue?`;

    this.confirmationService.confirm({
      message: msg,
      header: 'Confirm Release',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Release Jobs',
      rejectLabel: 'Cancel',
      accept: () => {
        this.doReleaseJobs();
      },
      reject: () => {},
    });
  }

  doReleaseJobs() {
    this.releasingJobs = true;

    const jobIds = this.selectedJobs.map((job) => {
      return job.id;
    });

    this.vmeInboxjobsService
      .releaseJobs(jobIds)
      .then(() => {
        this.filter.next(this.filterVal);
        this.messageService.add(Message.Info('Selected jobs released from Hold'));
      })
      .catch(() => {
        this.messageService.add(Message.Error('Error occurred releasing selected jobs'));
      })
      .finally(() => {
        this.releasingJobs = false;
        this.selectedJobs = [];
        this.selectedJob = null;
      });
  }

  enableGrabForSelectedJobs() {
    const message = this.anySelectedOnHold()
      ? 'The hold periods for selected jobs have not ended. Routes containing these jobs will be shown to suppliers, but the jobs will still not be visible in standard Job Search until the hold periods end. Please confirm you want to enable grab for these jobs.'
      : 'Enabling Grab will make these jobs visible in both Route Search & Job Search. The jobs will be auto-directed. Please confirm you want to enable grab for these jobs.';

    this.confirmationService.confirm({
      message,
      header: 'Enable Grab Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Enable Grab',
      rejectLabel: 'Cancel',
      accept: () => this.updateGrabDisabledState(false),
      reject: () => {},
    });
  }

  disableGrabForSelectedJobs() {
    this.confirmationService.confirm({
      message:
        'Disabling grab for these jobs will make the jobs invisible in all Job & Route Inboxes. The jobs will not be auto-directed. Please confirm you want to disable grab for these jobs.',
      header: 'Disable Grab Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Disable Grab',
      rejectLabel: 'Cancel',
      accept: () => this.updateGrabDisabledState(true),
      reject: () => {},
    });
  }

  updateGrabDisabledState(disableGrab: boolean) {
    if (disableGrab) {
      this.disablingGrab = true;
    } else {
      this.enablingGrab = true;
    }

    const jobIds = this.selectedJobs.map((job) => {
      return job.id;
    });

    this.jobService
      .updateGrabDisabledState(
        {
          jobIds: jobIds,
          grabDisabled: disableGrab,
        },
        true,
      )
      .then(() => {
        this.filter.next(this.filterVal);
        const action = disableGrab ? 'disabled' : 'enabled';
        const message = `Grab ${action} for the selected job${jobIds.length === 1 ? '' : 's'}`;

        this.messageService.add(Message.Info(message));
      })
      .catch(() => {
        this.messageService.add(
          Message.Error('Error occurred updating grab status for selected jobs'),
        );
      })
      .finally(() => {
        this.disablingGrab = false;
        this.enablingGrab = false;
        this.selectedJobs = [];
        this.selectedJob = null;
      });
  }

  allSelectedOnHold() {
    return this.selectedJobs?.every((job) => job.statusName == 'Held');
  }

  anySelectedOnHold() {
    return this.selectedJobs?.some((job) => job.statusName == 'Held');
  }

  anySelectedGrabEnabled() {
    return this.selectedJobs?.some((job) => !job.grabDisabled);
  }

  anySelectedGrabDisabled() {
    return this.selectedJobs?.some((job) => job.grabDisabled);
  }

  loadRoutesInbox(): void {
    const isAssigned = this.selectedJob?.supplierId != null;

    const queryParams: any = {
      ['jobNumberOrVehicleReg']: this.selectedJob.jobNumber,
    };

    if (isAssigned) {
      queryParams.extender = 2; //If it's already grabbed then we know we're filtering on Extensions - so default search to this :)
    }

    this.router.navigate(['app/routes-inbox'], {
      queryParams: queryParams,
    });
  }

  loadRouteInboxEnabledFlag(): void {
    this.routeRecommendationService.isRouteSearchEnabled().then((res) => {
      this.routeInboxEnabled = res;
    });
  }

  getRoutesContainingJobCount(): void {
    this.routeRecommendationService.getRouteCountByJobId(this.selectedJob.id).then((count) => {
      this.routesContainingJobCount = count;
      console.log('Routes containing job count: ', this.routesContainingJobCount);
    });
  }
}
